import { useState } from 'react';
const useSorting = () => {
    const [sortOptions, setSortOptions] = useState(undefined);
    const sortFormatted = sortOptions
        ? `${sortOptions.direction === 'desc' ? '-' : ''}${sortOptions.sortField}`
        : undefined;
    const handleSort = (sortField) => {
        if (!sortOptions || sortOptions.sortField !== sortField) {
            setSortOptions({
                sortField,
                direction: 'asc',
            });
            return;
        }
        if (sortOptions.direction === 'asc') {
            setSortOptions({
                sortField,
                direction: 'desc',
            });
            return;
        }
        setSortOptions(undefined);
    };
    return {
        sortFormatted,
        sortOptions,
        handleSort,
    };
};
export default useSorting;
